import { Box } from "@mui/material";
import styles from "../CalendarDay.module.css";
import { getIndicatorColor } from "./PartOfDay.helpers";

interface IPartOfDayProps {
    hasSlots: boolean;
    label: string;
    dataTestIdSuffix: string;
}

export default function PartOfDay({ hasSlots, label, dataTestIdSuffix }: IPartOfDayProps) {
    if (!hasSlots) return null;
    return (
        <Box
            data-test-id={`part_of_day_${label}_${dataTestIdSuffix}`}
            className={styles.indicator}
            sx={{ backgroundColor: getIndicatorColor(label) }}
            title={label}
        />
    );
}
